import { getDate, getGabja } from "../util";
// import AllLuck from "../components/AllLuck";
import ThreeLuck from "../components/ThreeLuck";
import TodayLuck from "../components/TodayLuck";
import { useKakaoStore } from "../store/useKakao";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGPTStore } from "../store/useGPT";
import KoreanLunarCalendar from "korean-lunar-calendar";
import ResultImage from "../components/ResultImage";
import { isIOS } from "react-device-detect";
import KakaoShareButton from "../components/KakaoShareButton";
import html2canvas from "html2canvas";
import SajuContents from "../components/SajuContents";
import LoginPopup from "../components/LoginPopup";

function ResultPage() {
  // 컴포넌트가 마운트될 때 "등록 완료" 이벤트 전송
  useEffect(() => {
    if (typeof (window as any).fbq === "function") {
      (window as any).fbq("track", "CompleteRegistration");
    }
  }, []);

  useEffect(() => {
    const updateMainStyle = () => {
      const mainElement = document.querySelector(".main_container main");
      if (mainElement instanceof HTMLElement) {
        // iOS 기기인 경우 Kakao 브라우저를 포함하여 항상 추가 패딩 적용
        const additionalPadding = isIOS ? 120 : 0;
        mainElement.style.paddingBottom = `${additionalPadding}px`;
      }
    };

    updateMainStyle();
    window.addEventListener("resize", updateMainStyle);
    return () => window.removeEventListener("resize", updateMainStyle);
  }, []);

  const { isLoggedIn, kakaoUser, postData } = useKakaoStore();

  const { getSajuLoading, result, getSaju } = useGPTStore();

  const [isLoading, setIsLoading] = useState(true);
  const [loadingProgress, setLoadingProgress] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn || !kakaoUser || !postData) {
      navigate("/");
      return;
    }

    const { birthday, birthyear } = kakaoUser.kakao_account;

    let birthDayJu = "신해";

    if (birthyear && birthday) {
      const calendar = new KoreanLunarCalendar();
      const month = parseInt(birthday.slice(0, 2));
      const day = parseInt(birthday.slice(2, 4));
      calendar.setSolarDate(parseInt(birthyear), month, day);
      birthDayJu = calendar.getKoreanGapja().day.replace("일", "");
    }

    // ✅ 0~90%까지 자동으로 증가하는 로딩 바
    const interval = setInterval(() => {
      setLoadingProgress((prev) => (prev < 90 ? prev + 15 : prev));
    }, 1500);

    // trkId 가져오기
    const trkId = localStorage.getItem("trkId");

    // ✅ 실제 API 호출
    getSaju({
      id: kakaoUser.id,
      birthDayJu: birthDayJu,
      someDayJu: getGabja(0),
      trkId: trkId ? trkId : "",
    });

    return () => clearInterval(interval);
  }, [getSaju, isLoggedIn, kakaoUser, navigate, postData]);

  // ✅ API 응답 완료 감지 → 로딩 종료 처리
  useEffect(() => {
    if (!getSajuLoading) {
      setLoadingProgress(100); // ✅ 100%로 즉시 변경
      setTimeout(() => {
        setIsLoading(false);
      }, 1000); // ✅ 300ms 후 로딩 화면 제거
    }
  }, [getSajuLoading]);

  // 결과 페이지 이미지 저장 함수 (쿠팡 배너 제외)
  const mainRef = useRef<HTMLElement>(null);
  const todayLuckRef = useRef<HTMLElement>(null);
  const saveResultImage = () => {
    if (!mainRef.current || !todayLuckRef.current) return;

    // 높이 바꾸기
    mainRef.current.style.height = `${
      mainRef.current.scrollHeight - 271 - 132 - 36 - 24 //
    }px`;

    // 그라데이션 삭제
    todayLuckRef.current.classList.add("screenshot");
    // todayLuckRef.current.classList.remove("name_luck_result_text");

    // 캡쳐 옵션: scrollWidth/scrollHeight로 전체 크기를 지정하고, 배너는 무시
    html2canvas(mainRef.current, {
      // banner_wrapper 클래스를 가진 요소는 캡쳐 대상에서 제외
      ignoreElements: (element) =>
        element.classList.contains("banner_wrapper") ||
        element.classList.contains("kakao_button") ||
        element.classList.contains("gradient-button") ||
        element.tagName === "FOOTER",
      useCORS: true, // 필요한 경우 CORS 이미지도 처리
    })
      .then((canvas) => {
        const imageURL = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = imageURL;
        link.download = "운세_결과.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("이미지 저장 실패:", error);
      });

    // 높이 원상복구
    mainRef.current.style.height = "100%";
    mainRef.current.scrollTop = mainRef.current.scrollHeight;
  };

  // 처음으로 돌아가기 버튼
  const onClickGoFirst = useCallback(() => {
    navigate("/");
  }, [navigate]);

  if (!result && !isLoading) {
    return (
      <div id="result_page" className="main_container">
        <div className="result_loading">
          <div className="legend_backdrop">
            <div className="many_people_img"></div>
            <div className="many_people_text">지금은 접속자가 많아요 😭</div>
            <div className="many_people_small_text">
              잠시 후에 다시 시도해주세요!
            </div>
            <div className="many_people_small_text">
              죄송한 마음을 담아 꽃다발을 선물합니다 🌸
            </div>
            <button
              style={{ marginBottom: 0, marginTop: 24 }}
              onClick={onClickGoFirst}
              className="gradient-button"
            >
              처음으로 돌아가기
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="result_page" className="main_container">
      {!isLoading && <LoginPopup />}
      <main ref={mainRef}>
        {/* 기본 정보 */}
        <div className="short_date">{getDate(0).short}</div>
        <div className="name_luck_result">
          <span className="user_name">{result?.name || "선생"}</span>님의{" "}
          <span
            ref={todayLuckRef}
            className={`name_luck_result_text ${result?.color || "black"}`}
          >
            오늘의 운세
          </span>
        </div>

        <ResultImage imageKey={result?.imageKey || "갑자"} />

        {/* 오늘의 행운 */}
        <TodayLuck
          color={result?.color || "black"}
          gift={result?.gift || "https://link.coupang.com/a/ccQsNr"}
          giftKey={result?.giftKey || "우산"}
          food={result?.food || "https://link.coupang.com/a/ccQsNr"}
          foodKey={result?.foodKey || "흰쌀밥"}
          number={result?.number || 7}
        />

        {/* 사주 상품 슬라이더 */}
        <SajuContents />

        {/* 운세 총운 */}
        {/* <AllLuck
          content={
            result?.totalContext ||
            "내일은 선생님께서 굳건한 나무가 바람을 맞이하는 날처럼, 힘든 난관 속에서도 자신만의 뿌리를 깊게 내리고 있습니다. 날카로운 바람이 실을 송두리째 흔들 수 있으나, 이를 통해 더욱 강해질 기회가 주어지는 날입니다. 예상치 못한 속상한 소식이나 사람과의 갈등이 있을 수 있으나, 통찰력을 발휘해 현명하게 대처하면 새로운 지혜를 얻게 될 것입니다. 조화롭게 흐르는 물이 마르지 않는 척도를 지니듯, 당장 눈앞의 어려움에 호흡을 가다듬고 임하면 생각지도 못한 수확을 기대할 수 있습니다. 정승호님의 지혜와 인내가 내일의 모든 일에 축복을 가져올 것입니다."
          }
        /> */}

        {/* 재물운, 연애운, 직장운 */}
        <ThreeLuck
          money_score={result?.moneyScore || 60}
          money_title={result?.moneyTitle || "재물운"}
          money_sub_title={result?.moneySubTitle || "재물운"}
          money_content={
            result?.moneyContext ||
            "소소한 재물이 생기겠지만 큰 기대는 하지 않는 것이 좋습니다."
          }
          love_score={result?.loveScore || 75}
          love_title={result?.loveTitle || "연애운"}
          love_sub_title={result?.loveSubTitle || "연애운"}
          love_content={
            result?.loveContext ||
            "우연히 만나게 될 사람과의 대화가 기대되는 하루입니다."
          }
          job_score={result?.jobScore || 65}
          job_title={result?.jobTitle || "직장운"}
          job_sub_title={result?.jobSubTitle || "직장운"}
          job_content={
            result?.jobContext ||
            "작은 프로젝트에 주력하는 것이 효과적일 것입니다."
          }
        />

        {/* 쿠팡 배너 */}
        <div
          className="banner_wrapper"
          style={{
            width: "100%",
            padding: "12px 24px",
            marginTop: "24px",
          }}
        >
          <div className="all_luck_title">
            오늘 행운이 깃드는 상품들을 확인해보세요!
          </div>
          <iframe
            title="cps"
            src="https://ads-partners.coupang.com/widgets.html?id=835716&template=carousel&trackingCode=AF7074941&subId=&height=140&tsource="
            width="100%"
            height="216"
            referrerPolicy="unsafe-url"
          ></iframe>
        </div>

        {/* 카카오톡 공유버튼 */}
        <div className="share_buttons">
          <KakaoShareButton />

          <button onClick={saveResultImage} className="gradient-button">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              {/* <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--> */}
              <path d="M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z" />
            </svg>
            이미지로 저장하기
          </button>
        </div>

        {/* Footer */}
        <footer className={isIOS ? "ios-footer" : ""}>
          쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를
          제공받습니다.
        </footer>

        {/* 로딩 */}
        {isLoading && (
          <div className="result_loading">
            <div className="legend_backdrop">
              <div className="leaf_img"></div>
              <div className="loading_text">운세를 가져오고 있어요 😊</div>
              <div className="loading_bar_container">
                <div
                  className="loading_bar"
                  style={{ width: `${loadingProgress}%` }}
                ></div>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default ResultPage;
